import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from 'src/app/_services/Customer/customer.service';
import { NewQuotation } from 'src/app/Entites/quotation/quotation';
import { QuotationService } from 'src/app/_services/Quotation/quotation.service';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { float } from 'html2canvas/dist/types/css/property-descriptors/float';
import { ProductItemService } from 'src/app/_services/productItem/product-item.service';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
@Component({
  selector: 'app-addquotation',
  templateUrl: './addquotation.component.html',
  styleUrls: ['./addquotation.component.css'],
  providers: [Dateconfig, CustomLoaderCComponent]
})
export class AddquotationComponent implements OnInit {
  @ViewChild('ng-select') ngSelect;
  @BlockUI('singleSelect') blockUISingleSelect: NgBlockUI;
  @BlockUI('multipleSelect') blockUIMultipleSelect: NgBlockUI;
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  /**
     *
     * @param NgbModal      modal
     */
  public customerarray;
  NewQuotation = new NewQuotation()
  model: any = {};
  model1: any = {};
  rows1: any;
  rows: any;

  temp = [];
  public quotationItems = [];
  public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  loading = false;
  submitted = false;
  f: NgForm;
  f1: NgForm;

  customermodel: any = {}
  idQuotation: string;
  showcustomer: boolean = false;
  booleanvalue: boolean = false;
  public showCustomerdetails: boolean = false;
  public isgst: boolean = false;
  public maxdate;
  public idLoggedInEmployee: number;
  public lstitem = [];
  public customer: any = {}
  public isEnabled;
  keyword = 'quotationItem';

  constructor(
    private CustomerService: CustomerService,
    private quotationService: QuotationService,
    private router: ActivatedRoute,
    private routernav: Router,
    private modalpop: NgbModal,
    private dateconfig: Dateconfig,
    private spinner: CustomLoaderCComponent,
    private toastrService: ToastrService,
    private productItemService: ProductItemService
  ) {
    this.idLoggedInEmployee = Number(localStorage.getItem(LocalStorageConstants.ID));
  }

  ngOnInit() {
    this.spinner.showSpinner();
    this.maxdate = this.dateconfig.getcurrentdate();
    this.model.quotationEnquiryContact = "8686480808";
    this.CustomerService.GetAllCustomer().subscribe(Response => {

      if (Response != null) {
        this.rows = Response;
        this.customerarray = this.rows;
      }
      else {
        this.customerarray = [];
      }
      this.spinner.hideSpinner();

    });

    this.idQuotation = this.router.snapshot.queryParamMap.get('Id');
    this.customer = this.router.snapshot.queryParamMap.get('customer');
    this.idQuotation = atob(this.idQuotation);

    if (Number(this.idQuotation) > 0) {
      this.spinner.showSpinner();
      document.title = 'Update Quotation';
      this.breadcrumb = {
        'mainlabel': 'Update Quotation',
      };

      this.showcustomer = true;
      this.showCustomerdetails = true;
      this.booleanvalue = true;
      this.quotationService.getbyidQuotation(Number(this.idQuotation)).subscribe(Response => {
        this.rows = Response;
        this.temp = this.rows;
        this.model = this.rows;
        this.model = Response;
        this.lstitem = this.model.lstQuotationItems;
        this.model.quotationDate = this.dateconfig.getshortdate(this.model.quotationDate);
        this.customermodel.customerAddress = this.model.customerAddress;
        this.customermodel.customerEmail = this.model.customerEmail;
        this.customermodel.customerFirstName = this.model.customerFirstName;
        this.customermodel.customerFullName = this.model.customerFullName;
        this.customermodel.customerGSTNO = this.model.customerGSTNO;
        this.customermodel.customerGSTNO = this.model.customerGSTNO;
        this.customermodel.idCustomer = this.model.idCustomer;

        if (this.rows.quotationGSTIsExcluded == "false") {
          let x = document.getElementById("quotationGSTIsExcluded") as HTMLInputElement;
          var sd = x.checked;
          this.isEnabled = false;
          this.model.quotationGSTIsExcluded = false;
          this.isgst = false;
          this.calculatetotal();
        }
        if (this.rows.quotationGSTIsExcluded == "true") {
          this.model.quotationGSTIsExcluded = true;
          this.isEnabled = false;
          this.isgst = true;
          this.calculatetotal();
        }
        this.bindformcustomer(this.customermodel);
        // this.model.patientPrescriptionsDate = this.dateconfig.coverttoshort(this.rows.patientVisitDate)
        this.quotationItems = this.rows.lstQuotationItems;
        this.calculatetotal();
        this.spinner.hideSpinner();
      });
    }
    else {
      this.NewQuotation = new NewQuotation();
      this.quotationItems.push(this.NewQuotation);
      this.model.quotationDate = this.dateconfig.getcurrentdate();
      this.breadcrumb = {
        'mainlabel': 'Add Quotation',
      };
    }
  }

  bindformcustomer(selectcustomerdata) {
    this.showcustomer = false;
    if (selectcustomerdata == null) {
      this.cancel();
    }
    else {
      this.customermodel = selectcustomerdata;
      this.model.selectcustomer = selectcustomerdata;
      this.showcustomer = true;
    }
  }

  AddForm() {
    this.NewQuotation = new NewQuotation()
    this.quotationItems.push(this.NewQuotation);
  }

  RemoveForm(index) {
    if (this.quotationItems[index].idQuotationItem > 0 || this.quotationItems[index].idQuotationItem != null) {
      this.quotationItems[index].operationState = "d";
      this.quotationItems[index].quotationItem = "d";
    }
    else {
      this.quotationItems[index].operationState = "d";
      this.quotationItems[index].quotationItem = "d";

    }
    this.calculatetotal();
  }

  cancel() {
    if (Number(this.idQuotation) > 0) {
      this.routernav.navigate(['/quotation/allquotation']);
    }
    this.showcustomer = false;
    this.showCustomerdetails = false;
    this.model = {};
    this.customermodel = {};
    this.model.quotationDate = this.dateconfig.getcurrentdate();
    this.model.quotationEnquiryContact = "8686480808";
    this.modalpop.dismissAll();
    this.quotationItems.slice(0, this.quotationItems.length);
  }

  GstExcluded() {
    if (this.model.quotationGSTIsExcluded == undefined || !this.model.quotationGSTIsExcluded) {
      this.isgst = true;
      for (var i = 0; i < this.quotationItems.length; i++) {
        this.quotationItems[i].quotationItemGST = 0;
        this.quotationItems[i].operationState = "u";
      }
      this.calculatetotal();
    }
    else if (this.model.quotationGSTIsExcluded) {
      this.isgst = false
      this.calculatetotal();
    }
  }

  public calculatetotal() {
    this.model.totalAmount = 0;
    for (var i = 0; i < this.quotationItems.length; i++) {
      if (this.quotationItems[i].quotationItemRate && this.quotationItems[i].quotationItemQuantity && this.quotationItems[i].operationState != "d") {
        this.quotationItems[i].quotationAmmount = this.quotationItems[i].quotationItemQuantity * this.quotationItems[i].quotationItemRate;
        if (this.isgst == false && this.quotationItems[i].quotationItemGST) {
          var GST_Amount = (this.quotationItems[i].quotationAmmount * this.quotationItems[i].quotationItemGST) / 100;
          this.quotationItems[i].quotationAmmount = this.quotationItems[i].quotationAmmount + GST_Amount;
          this.quotationItems[i].quotationAmmount = Math.round(this.quotationItems[i].quotationAmmount);
        }
        this.model.totalAmount = this.model.totalAmount + this.quotationItems[i].quotationAmmount;
      }
    }
  }

  savequotation(isValid: any) {
    for (var i = 0; i < this.quotationItems.length; i++) {
      if (this.quotationItems[i].quotationItem == '' || this.quotationItems[i].quotationItem == undefined) {
        isValid = false;
        break;
      }
    }
    if (isValid) {
      this.spinner.showSpinner();
      if (Number(this.idQuotation) < 0 || this.idQuotation == "ée") {
        for (var i = 0; i < this.quotationItems.length; i++) {
          if (this.quotationItems[i].operationState == "d") {
            this.quotationItems.splice(i, 1);
          }
        }
        if (this.model.quotationGSTIsExcluded) {
          this.model.quotationGSTIsExcluded = "true";
        }
        else {
          this.model.quotationGSTIsExcluded = "false";
        }
        this.model.lstQuotationItems = this.quotationItems;
        this.model.idCustomer = this.model.selectcustomer.idCustomer;
        this.model.createdBy = this.idLoggedInEmployee;
        this.quotationService.savequotation(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
              window.open('/viewquotation?Id=' + btoa(res.idQuotation) + '', '_blank');
              this.cancel();
              this.routernav.navigate(['/quotation/allquotation']);
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
      else if (Number(this.idQuotation) > 0) {
        for (var i = 0; i < this.quotationItems.length; i++) {
          if (this.quotationItems[i].idQuotationItem == undefined && this.quotationItems[i].operationState == "d") {
            this.quotationItems.splice(i, 1);
          }
        }
        this.model.lstQuotationItems = this.quotationItems;
        if (this.model.quotationGSTIsExcluded) {
          this.model.quotationGSTIsExcluded = "true";
        }
        else {
          this.model.quotationGSTIsExcluded = "false";
        }
        this.model.modifiedBy = this.idLoggedInEmployee;
        this.model.idCustomer = this.model.selectcustomer.idCustomer;
        this.quotationService.updarequotation(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
              window.open('/viewquotation?Id=' + btoa(res.idQuotation) + '', '_blank');
              this.cancel();
              this.routernav.navigate(['/quotation/allquotation']);
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
    }
  }

  SaveCustomer(isValid: any) {
    if (isValid) {
      if (this.model.idCustomer == undefined) {
        this.spinner.showSpinner();
        this.model.createdBy = this.idLoggedInEmployee;
        this.CustomerService.savecustomer(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.spinner.showSpinner();
              this.cancel();
              this.customerarray.push(res);
              this.bindformcustomer(res);
              this.model.selectcustomer = res;
              this.customerarray = [...this.customerarray];
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
    }
  }

  addcustomer(model: any) {
    this.model.action = "Add Customer"
    this.modalpop.open(this.modalContent, {
      size: 'lg', backdrop: 'static',
      keyboard: false
    });
  }

  calculateammounttotal(i) {
    this.quotationItems[i].quotationItemRate = 0;
    if (this.quotationItems[i].quotationItemQuantity && this.quotationItems[i].quotationAmmount) {
      this.quotationItems[i].quotationItemRate = this.quotationItems[i].quotationAmmount / this.quotationItems[i].quotationItemQuantity;
      if (this.isgst == false && this.quotationItems[i].quotationItemGST) {
        //  var GST_Amount = (this.quotationItems[i].quotationItems * this.quotationItems[i].quotationItemGST) / 100;
        var x = (this.quotationItems[i].quotationItemRate - (this.quotationItems[i].quotationItemRate * (100 / (100 + this.quotationItems[i].quotationItemGST))));
        this.quotationItems[i].quotationItemRate = this.quotationItems[i].quotationItemRate - Number(x);
        this.quotationItems[i].quotationItemRate = Number((this.quotationItems[i].quotationItemRate).toFixed(2));
      }
      this.calculatetotal();
    }
  }

  updateOperationState(i) {
    if (this.quotationItems[i].idQuotationItem != undefined) {
      this.quotationItems[i].operationState = "u"
    }
  }

  onScan(index) {
    this.spinner.showSpinner();
    this.productItemService.GetProductItemByBarCode(this.quotationItems[index].quotationItem).subscribe(Response => {
      if (Response != null) {
        this.quotationItems[index].quotationItem = Response.productItemDescription;
        this.quotationItems[index].quotationItemGST = Response.productGST;
        this.quotationItems[index].quotationItemHSNSAC = Response.productHSN;
        this.quotationItems[index].quotationItemQuantity = 1;
        this.quotationItems[index].quotationAmmount = 1 * Response.productItemPrice;
        this.calculateammounttotal(index)
        this.calculatetotal();
      }
      else {
        this.toastrService.warning("Barcode doeen't exist.", '', { timeOut: 2000, closeButton: true });
      }
      this.spinner.hideSpinner();
    });
  }
  // bindquotationItem(item,i){
  //   this.quotationItems[i].quotationItem=item.productItemDescription;
  //   this.quotationItems[i].quotationItemGST=item.productGST;
  //   this.quotationItems[i].quotationItemHSNSAC=item.productHSN;
  //   this.quotationItems[i].quotationItemRate=item.productItemPrice;
  //   this.quotationItems[i].quotationItemQuantity=1;
  //   this.quotationItems[i].quotationAmmount=1*this.quotationItems[i].quotationItemRate;
  // }
}
